import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';

export default function Navbar({ lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggle = () => setLang(lang === 'ar' ? 'en' : 'ar');
  const brand = lang === 'ar' ? 'يوم التأسيس السعودي 300 عام' : 'Saudi Founding Day 300 Years';
  const toggleLabel = lang === 'ar' ? 'English' : 'العربية';

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background/80 backdrop-blur-md border-b border-primary/15'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        {/* Language toggle */}
        <button
          data-testid="lang-toggle-btn"
          onClick={toggle}
          className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-primary/40 text-primary text-sm transition-all duration-300 hover:bg-primary/10 hover:border-primary/70"
        >
          <Globe className="w-4 h-4" />
          <span className="font-medium tracking-wide">{toggleLabel}</span>
        </button>

        {/* Brand */}
        <a
          href="#top"
          data-testid="nav-brand"
          className="font-arabic text-base md:text-lg lg:text-xl font-bold text-gradient-gold leading-[1.7] pb-1 transition-opacity duration-300 hover:opacity-80"
        >
          {brand}
        </a>
      </div>
    </header>
  );
}
